export default __webpack_public_path__ + "static/media/logo-algostudy-n.0ffbc77f.webp";